import React from "react";
import "../../styles/commons/SolutionsBar.css";

import logoCirculumAI from "../../assets/brand/circulumai-logo.png";

import logoConsoleAdmin from "../../assets/solutions/console-admin.png";
import logoChatbotSolution from "../../assets/solutions/chatbot.png";
import logoGamesQuiz from "../../assets/solutions/games-quiz.png";
import logoAssistantsMetier from "../../assets/solutions/assistants-metier.png";
import logoAnalyticsIA from "../../assets/solutions/analytics-ia.png";
import logoGovernance from "../../assets/solutions/governance.png";
import logoSecurity from "../../assets/solutions/security.png";

export const SOLUTIONS = [
  {
    id: "consolAdmin",
    label: "CirculumAdmin",
    subtitle: "",
    soon: true,
    accent: "cyan",
    logo: logoConsoleAdmin,
  },
  {
    id: "chatbot",
    label: "CirculumTalk",
    subtitle: "",
    soon: false,
    accent: "indigo",
    logo: logoChatbotSolution,
  },
  {
    id: "games",
    label: "CirculumChess",
    subtitle: "",
    soon: true,
    accent: "cyan",
    logo: logoGamesQuiz,
  },
  {
    id: "assistants",
    label: "CirculumTeam",
    subtitle: "",
    soon: true,
    accent: "violet",
    logo: logoAssistantsMetier,
  },
  {
    id: "analytics",
    label: "CirculumAnalytics",
    soon: true,
    accent: "sky",
    logo: logoAnalyticsIA,
  },
  {
    id: "governance",
    label: "CirculumGov",
    subtitle: "",
    soon: true,
    accent: "sky",
    logo: logoGovernance,
  },
  {
    id: "security",
    label: "CirculumSecurity",
    subtitle: "",
    soon: true,
    accent: "sky",
    logo: logoSecurity,
  },
];

export const SOLUTIONS_FALLBACK_LOGO = logoCirculumAI;

export default function SolutionsBar({
  selectedSolutionId,
  onSelectSolution,
  footerText = "Solutions en cours de developpement.",
  solutions = SOLUTIONS,
  fallbackLogo = SOLUTIONS_FALLBACK_LOGO,
}) {
  return (
    <aside className="demo-sidebar">
      <div className="demo-solutions-head">
        <div className="demo-solutions-title">Solutions</div>
        <div className="demo-solutions-sub">Choisissez une expérience CirculumAI</div>
      </div>

      <nav className="demo-solutions-list" aria-label="Solutions en démo">
        {solutions.map((s) => {
          const isActive = selectedSolutionId === s.id;

          return (
            <button
              key={s.id}
              type="button"
              className={
                "demo-solution-card" +
                (isActive ? " is-active" : "") +
                (s.soon ? " is-soon" : "") +
                ` accent-${s.accent}`
              }
              onClick={() => onSelectSolution(s)}
            >
              <span className="demo-solution-ico" aria-hidden="true">
                <img
                  className="demo-solution-logo"
                  src={s.logo || fallbackLogo}
                  alt=""
                  aria-hidden="true"
                />
              </span>

              <span className="demo-solution-text">
                <span className="demo-solution-topline">
                  <span className="demo-solution-label">{s.label}</span>
                </span>

                <span className="demo-solution-subtitle">{s.subtitle}</span>
              </span>

              <span className="demo-solution-chevron" aria-hidden="true">
                <IconChevron />
              </span>
            </button>
          );
        })}
      </nav>

      <div className="demo-sidebar-footer">
        <span className="demo-sidebar-footline">{footerText}</span>
      </div>
    </aside>
  );
}

function IconChevron() {
  return (
    <svg viewBox="0 0 24 24" className="demo-solution-chev-ico" aria-hidden="true">
      <path
        d="M9 6l6 6-6 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}